// extracted by mini-css-extract-plugin
export default {"root":"accordion_root__qxmR8","closed":"accordion_closed__FUvP-","content":"accordion_content__b+RsJ","header":"accordion_header__PMX-5","disabled":"accordion_disabled__TDbVy"};